import React, { FC } from "react";

import { Link, LinkProps, useTheme } from "@mui/material";

import { IgTypography } from "./IgTypography";

interface IgTypographyProps extends LinkProps {
  disabled?: boolean;
  isDarkColorVariant?: boolean;
}

/**
 * @see Link
 * @see IgTypography
 */
export const IgLink: FC<IgTypographyProps> = (props) => {
  const { children, sx, disabled, variant, isDarkColorVariant, ...rest } =
    props;
  const theme = useTheme();
  if (disabled) {
    return (
      <IgTypography
        variant={variant ?? "body1"}
        sx={{
          color: theme.palette.text.interactive.accent.disabled,
          ...sx,
        }}
        onClick={undefined}
        {...rest}
      >
        {children}
      </IgTypography>
    );
  }
  return (
    <Link
      variant={variant ?? "body1"}
      {...rest}
      underline={"hover"}
      sx={{
        "&:hover, &:focus": {
          cursor: "pointer",
          color: isDarkColorVariant
            ? `${theme.palette.text.dark} !important`
            : `${theme.palette.text.interactive.accent.hover} !important`,
        },
        color: isDarkColorVariant
          ? `${theme.palette.text.dark} !important`
          : `${theme.palette.text.accent} !important`,
        ...sx,
      }}
    >
      {children}
    </Link>
  );
};
